import { STATUS_LABELS, STATUS_TONE } from '../../domain/legalAssumptions';
import { formatBps, formatDateLabel } from '../../domain/equityEngine';
import type { MilestoneCalculation } from '../../domain/types';

interface MilestoneCardProps {
  calculation: MilestoneCalculation;
  selected: boolean;
  onSelect: () => void;
}

export function MilestoneCard({
  calculation,
  selected,
  onSelect,
}: MilestoneCardProps) {
  const milestone = calculation.milestone;
  const isGate = milestone.id === 'M1';
  const tone = STATUS_TONE[calculation.status];

  return (
    <article
      className={`milestone-card ${selected ? 'is-selected' : ''}`}
      aria-label={`${milestone.id} ${milestone.title}`}
    >
      <button className="milestone-card-main" type="button" onClick={onSelect}>
        <span className="milestone-card-kicker">
          {milestone.id}
          {isGate ? ' / 全局前置' : ''}
        </span>
        <span className="milestone-card-title">{milestone.title}</span>
        <span className={`state-badge tone-${tone}`}>{STATUS_LABELS[calculation.status]}</span>
      </button>

      <div className="milestone-card-body">
        <p>{milestone.description}</p>
        {milestone.condition ? <p className="condition-note">{milestone.condition}</p> : null}

        <div className="milestone-metrics">
          <span>
            <strong>{formatBps(milestone.equityBps)}</strong>
            <em>最高权益</em>
          </span>
          <span>
            <strong>{calculation.vestingPercent}%</strong>
            <em>时间归属</em>
          </span>
          <span>
            <strong>{formatBps(calculation.exercisableBps)}</strong>
            <em>可行权</em>
          </span>
        </div>

        <div className="card-actions">
          <button
            className="ghost-button"
            type="button"
            onClick={onSelect}
            aria-label={`打开 ${milestone.id} 的条款来源`}
          >
            条款 {milestone.sourceClause}
          </button>
        </div>

        <dl className="compact-facts">
          <div>
            <dt>达成日</dt>
            <dd>{formatDateLabel(milestone.achievedAt)}</dd>
          </div>
          <div>
            <dt>成熟权益</dt>
            <dd>{formatBps(calculation.milestoneEarnedBps)}</dd>
          </div>
        </dl>
      </div>
    </article>
  );
}
